var React = require('react');

function LogoInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".tag{fill:none;stroke:#000;stroke-width:4px}.text{stroke-width:2px}.tag,.text{stroke-linecap:round;stroke-linejoin:round}")),React.createElement("path",{"className":"tag","d":"M16.508 10.55L2 19.559l.478.277 14.03 8.138M85 10.55l14.508 9.009-.478.277L85 27.974M79.69 2.425l-7.804 34.4","key":1}),React.createElement("path",{"className":"text","d":"M38.626 29.008a14.4 14.4 0 01-6.035 1.406q-5.449 0-5.449-5.762V12.211h-3.906V9.574h3.906V4.008h2.969v5.566h6.914v2.637h-6.914v11.641a4.5 4.5 0 00.82 2.881 2.7 2.7 0 002.227 1.025 11.807 11.807 0 004.941-1.113zm25.801.918h-4L51.79 19.809l-1.992 1.717v8.4h-3.05V2.367h3.05v15.8l9.55-8.593h3.887l-9.277 8.32z","key":2})]);
}

LogoInline.defaultProps = {"viewBox":"0 0 101.508 39.469"};

module.exports = LogoInline;

LogoInline.default = LogoInline;
